import { useQueryClient } from '@tanstack/react-query';

import { Modal } from '../../components/Modal';
import { useToast } from '../../components/Toast';
import { formatNombre } from '../../lib/format';

import { BulkCreditForm, type Destinataires } from './BulkCredit';

/** Ajout groupé depuis une sélection d'élèves (liste Élèves). */
export function BulkCreditDialog({
  open,
  onOpenChange,
  destinataires,
  onTermine,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  destinataires: Destinataires;
  onTermine: () => void;
}) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const nb = (destinataires.userIds?.length ?? 0) + (destinataires.emails?.length ?? 0);
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Ajouter des crédits"
      description={`${formatNombre(nb)} élève${nb > 1 ? 's' : ''} sélectionnée${nb > 1 ? 's' : ''}. Un aperçu s’affiche avant tout ajout.`}
      width={640}
    >
      {open && (
        <BulkCreditForm
          destinataires={destinataires}
          onAnnuler={() => onOpenChange(false)}
          onTermine={(credites) => {
            toast.succes(`${formatNombre(credites)} élève${credites > 1 ? 's' : ''} créditée${credites > 1 ? 's' : ''}.`);
            void queryClient.invalidateQueries({ queryKey: ['eleve'] });
            void queryClient.invalidateQueries({ queryKey: ['credits'] });
            onTermine();
          }}
        />
      )}
    </Modal>
  );
}
